let breakpoints = {
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isSmallScreen() {
      return this.$vuetify.breakpoint.smOnly;
    },
    isMediumScreen() {
      return this.$vuetify.breakpoint.mdOnly;
    },
    isLargeScreen() {
      return this.$vuetify.breakpoint.lgOnly;
    },
    isExtraLargeScreen() {
      return this.$vuetify.breakpoint.xlOnly;
    },
  },
};

export default breakpoints;
